// extracted by mini-css-extract-plugin
export default {"image":"FirstViewOrdersScreen_image__yu-Pf","body":"FirstViewOrdersScreen_body__2xaZH"};